
import { motion } from "framer-motion"

interface BillingCycleToggleProps {
    value: number // 1, 3, 6
    onChange: (value: number) => void
}

const options = [
    { value: 1, label: "Monthly" },
    { value: 3, label: "Quarterly", badge: "-15%", badgeClass: "text-green-700 bg-green-100 dark:bg-green-900/30 dark:text-green-400" },
    { value: 6, label: "6 Months", badge: "-25%", badgeClass: "text-orange-700 bg-orange-100 dark:bg-orange-900/30 dark:text-orange-400" },
]

export function BillingCycleToggle({ value, onChange }: BillingCycleToggleProps) {
    return (
        // The control used to lay out at its natural width — 393px of buttons in
        // a 343px column — so on a 375px phone the "Monthly" option hung off the
        // left edge, half its label cut away. It now starts from the width it is
        // given and divides that between the three options.
        <div className="flex w-full items-center justify-center">
            <div className="relative flex w-full max-w-sm items-center rounded-full border border-border bg-muted p-1 sm:max-w-md">
                {options.map((opt) => {
                    const selected = value === opt.value
                    return (
                        <button
                            key={opt.value}
                            type="button"
                            onClick={() => onChange(opt.value)}
                            /* Selection was carried by the sliding pill alone, which is
                               colour and position — nothing a screen reader can report. */
                            aria-pressed={selected}
                            className="relative z-10 flex min-h-11 flex-1 cursor-pointer items-center justify-center rounded-full px-2 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-muted sm:px-5"
                            style={{ color: selected ? undefined : "var(--muted-foreground)" }}
                        >
                            {selected && (
                                <motion.div
                                    layoutId="billing-pill"
                                    className="absolute inset-0 bg-background rounded-full shadow-sm border border-border/50"
                                    transition={{ type: "spring", stiffness: 400, damping: 30 }}
                                />
                            )}
                            <span className="relative z-10 flex items-center gap-1 whitespace-nowrap">
                                {opt.label}
                                {opt.badge && (
                                    <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${opt.badgeClass}`}>
                                        {opt.badge}
                                    </span>
                                )}
                            </span>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
